import { AttrField, BelongsToField, OrmModel, StringField } from 'vuex-orm-decorators'
import { modelNames } from '@/data/models/types'
import ByocPhone from '@/data/models/domain/services/byoc/ByocPhone'
import type { ForwardingDirection } from '@/data/repositories/domain/phoneNumbersRepository'
import ForwardAudio from '@/data/models/domain/ForwardAudio'
import type { ByocCarrierStatus, ByocUserCarrier } from '@/services/domain/byoc/types'

export enum ByocPhoneStatus {
  LINKED = 'linked',
  FAILED = 'failed',
}

@OrmModel(modelNames.BYOC_CARRIER_PHONE)
export default class ByocCarrierPhone extends ByocPhone {
  @AttrField()
  public userCarrier: ByocUserCarrier

  @StringField()
  public status: ByocPhoneStatus

  @StringField()
  public carrierStatus: ByocCarrierStatus

  @StringField()
  public forwardingType: ForwardingDirection

  @StringField(null)
  public forwardedTo: string | null

  @StringField()
  public forwardAudioId: string

  @BelongsToField(ForwardAudio, 'forwardAudioId')
  public forwardAudio: ForwardAudio | null
}
